import * as React from "react";
import { connect } from "react-redux";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { ITmdState } from "../../../reducers/index";
import "./TrialGroupLookupsLayout.scss";

interface ITrialGroupLookupsLayoutProps {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    loading?: boolean;
    children?: any;
}

interface ITrialGroupLookupsLayoutActions {}

type TrialGroupLookupsLayoutProps = ITrialGroupLookupsLayoutProps &
    ITrialGroupLookupsLayoutActions;

class TrialGroupLookupsLayout extends React.PureComponent<
    TrialGroupLookupsLayoutProps,
    any
> {
    constructor(props: TrialGroupLookupsLayoutProps) {
        super(props);
    }

    render() {
        const { loading, permissions, permission } = this.props;

        return (
            <RestrictedLayout loading={loading}>
                {permissions.length > 0 &&
                permission &&
                !AuthenticationHelper.hasPermission(permissions, permission) ? (
                    <div className="alert alert-warning d-flex">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>Permission Denied</span>
                    </div>
                ) : (
                    this.props.children
                )}
            </RestrictedLayout>
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: TrialGroupLookupsLayoutProps
): ITrialGroupLookupsLayoutProps => {
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    return {
        permissions: permissions,
        permission: ownProps.permission,
        loading: ownProps.loading,
        children: ownProps.children,
    };
};

const mapDispatchToProps = (_dispatch): ITrialGroupLookupsLayoutActions => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrialGroupLookupsLayout);
